<script lang="ts">
    import '../../../../css/website.pcss';
    import Footer from '$lib/components/Footer.svelte';
    import MainNavbar from '$lib/components/navigation/MainNavbar.svelte';
    import MenuItem from '$lib/components/navigation/MenuItem.svelte';
    import { t } from 'svelte-i18n';
    import { useLocaleContext } from '$lib/context.js';

    const lang = useLocaleContext();
</script>

<div>
    <MainNavbar>
        <MenuItem href="/{lang}/">{$t('website.sidebar.items.start')}</MenuItem>
        <MenuItem href="/{lang}#who-we-are">{$t('website.sidebar.items.who-we-are')}</MenuItem>
        <MenuItem href="/{lang}#partner">{$t('website.sidebar.items.partners')}</MenuItem>
        <MenuItem href="/{lang}#racing-and-tuning">{$t('website.sidebar.items.racing-and-tuning')}</MenuItem>
        <MenuItem href="/{lang}#history">{$t('website.sidebar.items.history')}</MenuItem>
        <MenuItem href="/{lang}/shop">{$t('website.sidebar.items.shop')}</MenuItem>
    </MainNavbar>
    <div class="overflow-x-hidden">
        <slot />
    </div>
    <Footer />
</div>
